<template>
  <div class="container">
    <img v-for="img in imageList" v-lazy="img" :key="img.index" />
    <!-- <video src="../../static/img/c_v.mp4" v-show="flag == 3" controls preload playsinline="true" webkit-playsinline="true" x5-playsinline="true" class="v1"></video> -->
    <video src="../../static/img/y_v.mp4" v-show="flag == 5" controls preload playsinline="true" webkit-playsinline="true" x5-playsinline="true" class="v2"></video>
    <video src="../../static/img/t_v.mp4" v-show="flag == 0" controls preload playsinline="true" webkit-playsinline="true" x5-playsinline="true" class="v2"></video>
  </div>
</template>
<script>
export default {
  name:'detail',
  data() {
    return{
      imageList:[],
      flag:'',
    }
  },
  created(){
    this.flag = this.$route.query.id;
    switch(this.$route.query.id){
      case 1:
        this.imageList = [//澄西中学旧址  江南第一所抗日中学
          'static/img/detail/h_01.jpg',
          'static/img/detail/h_02.jpg',
          'static/img/detail/h_03.jpg',
          'static/img/detail/h_04.jpg',
          'static/img/detail/h_05.jpg',
          'static/img/detail/h_06.jpg',
          'static/img/detail/h_07.jpg',
          'static/img/detail/h_08.jpg',
          'static/img/detail/h_09.jpg',
          'static/img/detail/h_10.jpg',
          'static/img/detail/h_11.jpg',
          'static/img/detail/h_12.jpg',
          'static/img/detail/h_13.jpg',
          'static/img/detail/h_14.jpg',
          'static/img/detail/h_15.jpg',
        ];
        break;
      case 4:
        this.imageList = [//渡江战役 
          'static/img/detail/d_01.jpg',
          'static/img/detail/d_02.jpg',
          'static/img/detail/d_03.jpg',
          'static/img/detail/d_04.jpg',
          'static/img/detail/d_05.jpg',
          'static/img/detail/d_06.jpg',
          'static/img/detail/d_07.jpg',
          'static/img/detail/d_08.jpg',
          'static/img/detail/d_09.jpg',
          'static/img/detail/d_10.jpg',
          'static/img/detail/d_11.jpg',
          'static/img/detail/d_12.jpg',
          'static/img/detail/d_13.jpg',
          'static/img/detail/d_14.jpg',
          'static/img/detail/d_15.jpg',
        ];
        break;
      case 3:
        this.imageList = [//炮台  要塞起义
          'static/img/detail/s_01.jpg',
          'static/img/detail/s_02.jpg',
          'static/img/detail/s_03.jpg',
          'static/img/detail/s_04.jpg',
          'static/img/detail/s_05.jpg',
          'static/img/detail/s_06.jpg',
          'static/img/detail/s_07.jpg',
          'static/img/detail/s_08.jpg',
          'static/img/detail/s_09.jpg',
          'static/img/detail/s_10.jpg',
          'static/img/detail/s_11.jpg',
          'static/img/detail/s_12.jpg',
          'static/img/detail/s_13.jpg',
          'static/img/detail/s_14.jpg',
          'static/img/detail/s_15.jpg',
        ];
        break;
      case 0:
        this.imageList = [//周庄陶城村 中共江阴一大召开
          'static/img/detail/t_01.jpg',
          'static/img/detail/t_02.jpg',
          'static/img/detail/t_03.jpg',
          'static/img/detail/t_04.jpg',
          'static/img/detail/t_05.jpg',
          'static/img/detail/t_06.jpg',
          'static/img/detail/t_07.jpg',
          'static/img/detail/t_08.jpg',
          'static/img/detail/t_09.jpg',
          'static/img/detail/t_10.jpg',
          'static/img/detail/t_11.jpg',
          'static/img/detail/t_12.jpg',
          'static/img/detail/t_13.jpg',
          'static/img/detail/t_14.jpg',
          'static/img/detail/t_15.jpg',
        ];
        break;
      case 5:
        this.imageList = [//原国民党要塞司令部 中国人民海军组建
          'static/img/detail/y_01.jpg',
          'static/img/detail/y_02.jpg',
          'static/img/detail/y_03.jpg',
          'static/img/detail/y_04.jpg',
          'static/img/detail/y_05.jpg',
          'static/img/detail/y_06.jpg',
          'static/img/detail/y_07.jpg',
          'static/img/detail/y_08.jpg',
          'static/img/detail/y_09.jpg',
          'static/img/detail/y_10.jpg',
          'static/img/detail/y_11.jpg',
          'static/img/detail/y_12.jpg',
          'static/img/detail/y_13.jpg',
          'static/img/detail/y_14.jpg',
          'static/img/detail/y_15.jpg',
        ];
        break;
      case 2:
        this.imageList = [//祝塘抗江战役馆 烽火遍地颜家桥
          'static/img/detail/z_01.jpg',
          'static/img/detail/z_02.jpg',
          'static/img/detail/z_03.jpg',
          'static/img/detail/z_04.jpg',
          'static/img/detail/z_05.jpg',
          'static/img/detail/z_06.jpg',
          'static/img/detail/z_07.jpg',
          'static/img/detail/z_08.jpg',
          'static/img/detail/z_09.jpg',
          'static/img/detail/z_10.jpg',
          'static/img/detail/z_11.jpg',
          'static/img/detail/z_12.jpg',
          'static/img/detail/z_13.jpg',
          'static/img/detail/z_14.jpg',
          'static/img/detail/z_15.jpg',
        ];
        break;
      /* case 3:
        this.imageList = [//陈毅演讲处 叶飞手书陈毅诗碑
          'static/img/detail/c_01.jpg',
          'static/img/detail/c_02.jpg',
          'static/img/detail/c_03.jpg',
          'static/img/detail/c_04.jpg',
          'static/img/detail/c_05.jpg',
          'static/img/detail/c_06.jpg',
          'static/img/detail/c_07.jpg',
          'static/img/detail/c_08.jpg',
          'static/img/detail/c_09.jpg',
          'static/img/detail/c_10.jpg',
          'static/img/detail/c_11.jpg',
          'static/img/detail/c_12.jpg',
          'static/img/detail/c_13.jpg',
          'static/img/detail/c_14.jpg',
          'static/img/detail/c_15.jpg',
        ];
        break; */
        default:
          break;
    }
  },
}
</script>
<style scoped>
img{
  display: block;
  width: 100%;
}
.v1{
  position: absolute;
  top: 28vw;
  left: 10vw;
  width: 80vw;
  height: auto;
}
.v2{
  position: absolute;
  top: 28vw;
  left: 10vw;
  width: 80vw;
  height: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/detail.vue